import React from "react";

const NewsLoading = () => (
  <div className="news-loading-status" role="status" aria-live="polite">
    <span className="news-loading-spinner" aria-hidden="true" />
    <strong>Your message is loading</strong>
    <p>Please wait while your important message from VisionTrak loads.</p>
  </div>
);

export default NewsLoading;
